import { Alert, Button, Checkbox, Dialog, FormControlLabel, FormGroup, Grid2, Snackbar, TextField } from "@mui/material";
import { Box, Fab } from "@mui/material";
import ReplyRoundedIcon from "@mui/icons-material/ReplyRounded";
import { useEffect, useState } from "react";
import axios from "axios";
import imageCompression from "browser-image-compression";
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';


function AdminEspec() {
  const [servicos, setServicos] = useState([]);
  const [equipe, setEquipe] = useState([]);
  const [selectedServico, setSelectedServico] = useState(null);
  const [profissionaisSelecionados, setProfissionaisSelecionados] = useState([]);
  const [formData, setFormData] = useState({
    id: "",
    name: "",
    descricao: "",
    text: "",
    foto: "",
    ordem: "",
  });
  const [image, setImage] = useState(null);
  const [showAddForm, setShowAddForm] = useState(false);
  const [errorText, setErrorText] = useState('');
  const [successText, setSuccessText] = useState('');
  const [error, setError] = useState(false);
  const [open, setOpen] = useState(false);
  const [openDialog, setOpenDialog] = useState(false)

  const handleClickDialog = () => {
    setOpenDialog(true);
  }

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
        return;
    }
    setError(false);
    setOpenDialog(false);
    setOpen(false);
  };


  const fetchServicos = async () => {
    try {
      const response = await axios.get(`https://api.sigmasystems.com.br/api/odontoluzzi/get-servicos`);
      if (Array.isArray(response.data)) {
        const sorted = [...response.data].sort((a, b) => a.name.localeCompare(b.name));
        setServicos(sorted);
      }
    } catch (error) {
      console.error("Erro na requisição:", error);
    }
  };

  useEffect(() => {
    fetchServicos();
  }, []);

  const handleSelectServico = (servico) => {
    if (showAddForm) {
      setShowAddForm(false)
    }
    if (selectedServico?.id === servico.id) {
      handleCancel();
    } else {
      axios
        .get(
          `https://api.sigmasystems.com.br/api/odontoluzzi/get-servicos?name=${servico.name}`
        )
        .then((response) => {
          const data = response.data;
          if (data) {
            setSelectedServico(servico);
            setFormData({
              id: data.servico.id || "",
              name: data.servico.name || "",
              descricao: data.servico.descricao || "",
              text: data.servico.text || "",
              foto: data.servico.foto || "",
              ordem: data.servico.ordem || "",
              fotoFile: null,
              fotoPreview: "",
            });
            const ids = data.profissional.map((p) => p.id);
            setProfissionaisSelecionados(ids)
          }
          return axios.get('https://api.sigmasystems.com.br/api/odontoluzzi/get-equipe');
       
        })
        .then((response) => {
          setEquipe(response.data);
        })
        .catch((error) => {
          console.error("Erro ao buscar especialidade:", error);
        });
    }
  };

  const handleImageChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
  
    try {
      
      const options = {
        maxSizeMB: 1,          // máximo 1MB
        maxWidthOrHeight: 1280, // redimensiona se maior
        useWebWorker: true,    // otimiza com webworker
      };
  
      let compressedFile = file;
  
      // só comprime se o arquivo for maior que 1MB
      if (file.size / 1024 / 1024 > 1) {
        compressedFile = await imageCompression(file, options);
      }
  
      const previewUrl = URL.createObjectURL(compressedFile);
  
      setFormData((prev) => ({
        ...prev,
        fotoFile: compressedFile,   
        fotoPreview: previewUrl,    
      }));
    } catch (error) {
      console.error("Erro ao comprimir a imagem:", error);
    }
  };

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleCancel = () => {
    setSelectedServico(null);
    setFormData({id:"", name: "", descricao: "", text: "", foto: "" });
    setImage(null);
    setProfissionaisSelecionados([])
    if(showAddForm) {
      setShowAddForm(false);
    }
  };

  const handleSave = async () => {
    try {
      const formDataToSend = new FormData();
      formDataToSend.append("name", formData.name);
      formDataToSend.append("descricao", formData.descricao);
      formDataToSend.append("text", formData.text);
      formDataToSend.append("profissionais", JSON.stringify(profissionaisSelecionados));
      formDataToSend.append("ordem", formData.ordem);


      if (formData.fotoFile) {
        formDataToSend.append("foto", formData.fotoFile); 
      }

      await axios.post(
        `https://api.sigmasystems.com.br/api/odontoluzzi/update-servico/${formData.id}`,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      setOpen(true);
      setSuccessText('Serviço Alterado!')
      fetchServicos();
      handleCancel();
    } catch (error) {
      setError(true);
      setErrorText('Erro ao alterar serviço!')
      console.error("Erro ao salvar serviço:", error);
    }
  };
  

  const handleToggleProfissional = (id) => {
    setProfissionaisSelecionados((prev) => 
    prev.includes(id) ? prev.filter((pid) => pid !== id) : [...prev, id]);
  }

  const handleOpenAdd = () => {
    setSelectedServico(null);
    setShowAddForm(true);
    setFormData([])
    setProfissionaisSelecionados([])
    getEquipe();
  }
  const handleAdd = async () => {
    try {
      const formDataToSend = new FormData();
      formDataToSend.append("name", formData.name);
      formDataToSend.append("descricao", formData.descricao);
      formDataToSend.append("text", formData.text);
      formDataToSend.append("profissionais", JSON.stringify(profissionaisSelecionados));

      if (formData.fotoFile) {
        formDataToSend.append("foto", formData.fotoFile); 
      }
      if (!formData.name || !formData.descricao || !formData.text){
        setError(true);
        setErrorText('Verifique os campos!')
        return error;
      }

      await axios.post(
        `https://api.sigmasystems.com.br/api/odontoluzzi/add-servico`,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      setOpen(true);
      setSuccessText('Serviço Cadastrado!')
      fetchServicos();
      handleCancel();
    } catch (error) {
      setError(true);
      setErrorText('Erro ao cadastrar serviço!')
      console.error("Erro ao salvar serviço:", error);
    }
  };
  
  const handleExcluir = async () => {
    try {
      const servico_id = formData.id;
      await axios.post(
        'https://api.sigmasystems.com.br/api/odontoluzzi/remove-servico',
        {id:servico_id},        
      );

      setOpen(true);
      setOpenDialog(false);
      setSelectedServico(null);
      fetchServicos();
      setSuccessText('Serviço excluído!')
    } catch (error) {
      setError(true);
      setErrorText('Erro ao excluir serviço!')
    }
  }

  const getEquipe = async () => {
    const response = await axios.get('https://api.sigmasystems.com.br/api/odontoluzzi/get-equipe');
    setEquipe(response.data);
  }

  return (
    <div className="container">
      <div className="body" style={{ justifyItems: "center", width: "100%" }}>
        <div className="adminMenuContainer">
          <div className="adminTitle">Especialidades</div>
          <div
            className="adminMenuContent"
            style={{
              maxWidth: "1280px",
              height: "fit-content",
              maxHeight:'700px',
              borderRadius: "0px 0px 10px 10px",
            }}
          >
            <Grid2 container spacing={2}>
              <Grid2 item>
                <Button
                  onClick={handleOpenAdd}
                  sx={{
                    color: "#fff",
                    height: 40,
                    width: 162,
                    borderRadius: "5px",
                    fontSize: "18px",
                    backgroundColor: "#B08E44",
                    textTransform: "none",
                    "&:hover": { color: "#fff", backgroundColor: "#041819" },
                  }}
                >
                  + ADICIONAR
                </Button>
              </Grid2>
              <Grid2 item>
                <Button
                  disabled={!selectedServico}
                  onClick={handleClickDialog}
                  sx={{
                    color: "#B08E44",
                    height: 40,
                    width: 162,
                    borderRadius: "5px",
                    fontSize: "18px",
                    backgroundColor: "none",
                    border: selectedServico ? "solid 2px #B08E44" : 'solid 2px #cfcfcf',
                    "&:hover": { color: "#fff", backgroundColor: "#041819" },
                  }}
                >
                  EXCLUIR
                </Button>
              </Grid2>
            </Grid2>

            <div className="adminSubTitle">Lista de Especialidades</div>
            <Grid2 container spacing={2}>
              {servicos.map((servico) => (
                <Grid2 item key={servico.id}>
                  <Button
                    sx={{
                      color:
                        selectedServico?.id === servico.id
                          ? "#fff"
                          : "#B08E44",
                      border:
                        selectedServico?.id === servico.id
                          ? "none"
                          : "2px solid #B08E44",
                      backgroundColor:
                        selectedServico?.id === servico.id ? "#B08E44" : "#fff",
                      "&:hover": {
                        backgroundColor: "#041819",
                        color: "#fff",
                      },
                    }}
                    variant={
                      selectedServico?.id === servico.id
                        ? "contained"
                        : "outlined"
                    }
                    onClick={() => handleSelectServico(servico)}
                  >
                    {servico.name}
                  </Button>
                </Grid2>
              ))}
            </Grid2>
            {showAddForm && (
              <div>
                <div className="adminSubTitle">Imagem</div>
                <Grid2 container spacing={2}>
                  <Grid2 item>
                    <img
                      src={
                        formData.fotoPreview
                          ? formData.fotoPreview
                          : "https://odontoluzzi.com.br/images/padrao/padraoServico.png"
                      }
                      alt="Nova Imagem"
                      style={{
                        width: "100%",
                        maxWidth:'400px',
                        height:'110px',
                        borderRadius: "8px",
                        objectFit:'cover'
                      }}
                    />
                  </Grid2>
                  <Grid2 item>
                    <label className="btnUpload">
                      <input
                        style={{ display: "none" }}
                        type="file"
                        accept="image/*"
                        onChange={handleImageChange}
                      />
                      Escolher<br/>Foto
                    </label>
                  </Grid2>
                </Grid2>

                <div className="adminSubTitle">Nome</div>
                <TextField
                  fullWidth
                  variant="outlined"
                  value={formData.name}
                  onChange={(e) => handleChange("name", e.target.value)}
                />

                <div className="adminSubTitle">Descrição</div>
                <TextField
                  fullWidth
                  multiline
                  variant="outlined"
                  value={formData.descricao}
                  onChange={(e) => handleChange("descricao", e.target.value)}
                />

                <div className="adminSubTitle">Texto</div>
                <TextField
                  fullWidth
                  multiline
                  variant="outlined"
                  value={formData.text}
                  onChange={(e) => handleChange("text", e.target.value)}
                />
                <Grid2 container spacing={2} sx={{marginTop:2}}>
                  <FormGroup row>                 
                    {equipe.map((equipe) => (
                      <Grid2 item key={equipe.id}>
                        <FormControlLabel control={<Checkbox sx={{'&.Mui-checked':{color:'#B08E44'}}} checked={profissionaisSelecionados.includes(equipe.id)} onChange={() => handleToggleProfissional(equipe.id)}/>} label={equipe?.name}/>
                      </Grid2>
                    ))} 
                    
                  </FormGroup>
                </Grid2>

                <Grid2 container spacing={2} sx={{ marginTop: 2 }}>
                  <Grid2 item>
                    <Button
                      variant="contained"
                      sx={{
                        backgroundColor: "#B08E44",
                        "&:hover": { backgroundColor: "#041819" },
                      }}
                      onClick={handleAdd}
                    >
                      Finalizar
                    </Button>
                  </Grid2>
                  <Grid2 item>
                    <Button
                      variant="outlined"
                      sx={{ border: "2px solid #B08E44", color: "#B08E44" }}
                      onClick={handleCancel}
                    >
                      Cancelar
                    </Button>
                  </Grid2>
                </Grid2>

                
              </div>)}

            {selectedServico && (
              <div>
                <div className="adminSubTitle">Ordem na Home</div>
                <select
                  className="selectOrder"
                  value={formData.ordem}
                  onChange={(e) => handleChange("ordem", e.target.value)}
                >
                  {Array.from({ length: servicos.length }).map((_, idx) => (
                    <option key={idx + 1} value={idx + 1}>
                      {idx + 1}
                    </option>
                  ))}
                </select>
                <div className="adminSubTitle">Imagem</div>
                <Grid2 container spacing={2}>
                  <Grid2 item>
                    <img
                      src={
                        formData.fotoPreview
                          ? formData.fotoPreview
                          : formData.foto ? `https://api.sigmasystems.com.br/api/odontoluzzi/uploads/especialidades/${formData.foto}`
                          : "https://odontoluzzi.com.br/images/padrao/padraoServico.png"
                      }
                      alt={formData.name}
                      style={{
                        width: "100%",
                        maxWidth:'400px',
                        height:'110px',
                        borderRadius: "8px",
                        objectFit:'cover'
                      }}
                    />
                  </Grid2>
                  <Grid2 item>
                    <label className="btnUpload">
                      <input
                        style={{ display: "none" }}
                        type="file"
                        accept="image/*"
                        onChange={handleImageChange}
                      />
                      Trocar Foto
                    </label>
                  </Grid2>
                </Grid2>

                <div className="adminSubTitle">Nome</div>
                <TextField
                  fullWidth
                  variant="outlined"
                  value={formData.name}
                  onChange={(e) => handleChange("name", e.target.value)}
                />

                <div className="adminSubTitle">Descrição</div>
                <TextField
                  fullWidth
                  multiline
                  variant="outlined"
                  value={formData.descricao}
                  onChange={(e) => handleChange("descricao", e.target.value)}
                />

                <div className="adminSubTitle">Texto</div>
                <TextField
                  fullWidth
                  multiline
                  variant="outlined"
                  value={formData.text}
                  onChange={(e) => handleChange("text", e.target.value)}
                />
                <Grid2 container spacing={2} sx={{marginTop:2}}>
                  <FormGroup row>                 
                    {equipe.map((equipe) => (
                      <Grid2 item key={equipe.id}>
                        <FormControlLabel control={<Checkbox sx={{'&.Mui-checked':{color:'#B08E44'}}} checked={profissionaisSelecionados.includes(equipe.id)} onChange={() => handleToggleProfissional(equipe.id)}/>} label={equipe?.name}/>
                      </Grid2>
                    ))} 
                    
                  </FormGroup>
                </Grid2>

                <Grid2 container spacing={2} sx={{ marginTop: 2 }}>
                  <Grid2 item>
                    <Button
                      variant="contained"
                      sx={{
                        backgroundColor: "#B08E44",
                        "&:hover": { backgroundColor: "#041819" },
                      }}
                      onClick={handleSave}
                    >
                      Finalizar
                    </Button>
                  </Grid2>
                  <Grid2 item>
                    <Button
                      variant="outlined"
                      sx={{ border: "2px solid #B08E44", color: "#B08E44" }}
                      onClick={handleCancel}
                    >
                      Cancelar
                    </Button>
                  </Grid2>
                </Grid2>
              </div>
            )}
          </div>

          <Box
            sx={{
              "& > :not(style)": { m: 1 },
              position: "absolute",
              bottom: 16,
              right: 16,
            }}
          >
            <Fab
              onClick={() => window.history.back()}
              variant="extended"
              sx={{
                backgroundColor: "#B08E44",
                color: "#fff",
                "&:hover": { backgroundColor: "#041819" },
              }}
            >
              <ReplyRoundedIcon sx={{ mr: 1 }} /> Voltar
            </Fab>
          </Box>
        </div>
      </div>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{vertical:'bottom',horizontal:'right'}}>
          <Alert
          onClose={handleClose}
          severity="success"
          variant="filled"
          sx={{ width: '100%' }}
          >
          {successText}
          </Alert>
      </Snackbar>
      <Snackbar open={error} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{vertical:'bottom',horizontal:'right'}}>
          <Alert
          onClose={handleClose}
          severity="error"
          variant="filled"
          sx={{ width: '100%' }}
          >
          {errorText}
          </Alert>
      </Snackbar>
      <Dialog
        open={openDialog}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Tem certeza que deseja excluir o serviço?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {formData.name}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button onClick={handleExcluir} autoFocus>
            EXCLUIR
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
export default AdminEspec;
